// extracted by mini-css-extract-plugin
module.exports = {"container":"tradeFooter_container__oKRlG"};